<template>
<div class="sidenav" :class="{ collapsed: !isOpen }">
  <ul class="sidenav-links">
    <li v-for="link in links" :key="link.url" class="list-group" @click="onLinkClick">
      <router-link
        :class="['nav-item', { collapsed: !isOpen }]"
        :active-class="isActive(link) ? 'active-link' : ''"
        :to="link.url"
        :exact="link.exact"
        v-if="isPermitionAllowedForRole(link.key, userRole)"
      >      
        <i :class="link.icon" :aria-label="link.title"></i>
        <span v-if='isOpen'>{{ link.title }}</span>
      </router-link>
      <div v-if="isOpen && link.sublinks?.length > 0" class="block-list">
        <ul class="list">
          <li v-for="sublink in link.sublinks" :key="sublink.url" class="list-group-sub">
            <router-link
              class="nav-item"
              active-class="active-link"
              :to="sublink.url"
              :exact="sublink.exact"
            >
              {{ sublink.title }}
            </router-link>
          </li>
        </ul>
      </div>
    </li>
  </ul>
  <div class="buttons-group">
    <Button v-if="theme !== 'light'" icon="pi pi-sun" severity="secondary" aria-label="Sun" @click="toggleTheme" />
    <Button v-if="theme === 'light'" icon="pi pi-moon" severity="secondary" aria-label="Moon" @click="toggleTheme" />
    <Button
      v-if="!isMobile"
      aria-label="Sidebar"
      @click="collapseExpand"
      variant="outlined"
    >
      <template #icon>
        <i :class="['pi pi-angle-right', { rotated: isOpen }]" />
      </template>
    </Button>
  </div>
  </div>
</template>

<script>
import { isPermitionAllowed, isPermitionAllowedForRole } from '@/permissions';
import { mapActions, mapGetters } from 'vuex';
import Button from 'primevue/button';

export default {
  components: {
    Button,
  },

  props: {
    isOpen: {
      type: Boolean,
      default: true,
    },
    onLinkClick: {
      type: Function,
      required: false
    }
  },

  computed: {
    ...mapGetters('ui', ['isMobile', 'theme']),

    userRole() {
      return this.$store.getters['user/getRoleCurentUser'];
    }
  },

  data() {
    return {
      links: [
        { title: "Отчёты", url: "/finances/payslips", iconName: "attach_money", icon: "pi pi-chart-bar", key: "payslipsPage" },
        { title: "Dashboard", url: "/dashboard", icon: "pi pi-th-large", key: "dashboardsPage" },
        //{ title: "Переводы", url: "/transactions", iconName: "sync", icon: "pi pi-sync", key: "transactionsPage" }, // добавляем в created только для мобильной версии
        { title: "Текущие балансы", url: "/balances", iconName: "sync", icon: "pi pi-money-bill", key: "balancesPage" },
        { title: "Взаиморасчёты", url: "/settlements", iconName: "sync", icon: "pi pi-wallet", key: "balancesPage" },        
      ],     
    }
  },

  created() {
    if (this.isMobile) {      
      this.links.splice(2, 0, { 
        title: "Переводы", 
        url: "/transactions", 
        iconName: "sync", 
        icon: "pi pi-sync", 
        key: "transactionsPage" 
      });
    }
  },
 
  methods: {
    isPermitionAllowed, isPermitionAllowedForRole,

    ...mapActions('ui', ['toggleTheme']),

    collapseExpand() {
      this.$emit("collapseExpand");
    },

    getIconPath(icon) {
      return require(`@/assets/icons/${icon}`);
    },

    isActive(item) {
      // Проверка на совпадение текущего пути с путем элемента (для родительских элементов)
      return this.$route.path === item.url; 
    },
  }
};
</script>

<style scoped>

.sidenav {
  width: 100%;
  height: calc(100vh - var(--header-height));
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

@media (max-width: 768px) {
  .sidenav {
    height: 100%;
  }
} 

.sidenav.collapsed {
  width: var(--side-bar-collapsed-width);
} 

.sidenav-links {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  margin: 0;
  transition: width 0.3s ease;
}

.list-group {
  min-width: 100%;
}

.nav-item {
  display: flex;
  align-items: center;
  justify-content: start;
  padding: 8px 12px;
  gap: 8px;
  text-decoration: none;
  width: 100%;
  transition: background 0.3s ease;
  border-radius: 4px;
  color: var(--text-light);
}

.nav-item.collapsed {
  justify-content: center;
}

.my-app-dark .nav-item {
  color: var(--text-dark);
}

.nav-item:hover {
  background-color: var(--p-primary-300);
  border-radius: 4px;
}

.active-link {
  background-color: var(--p-primary-500);
  border-radius: 4px;
}

.block-list {
  padding-left: 16px;
}

.list-group-sub {
  padding-left: 24px;
}

.buttons-group {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  justify-content: center;
}

.buttons-group button {
  width: 36px!important;
  height: 36px!important;
}

.expand-button i {
  transform: rotate(180deg);
  transition: transform 0.3s ease;
}

.expand-button.collapsed i {
  transform: rotate(0deg);
}

.icon {
  color: var(--Theme-Primary, #FFE5D0);
}

.rotated {
  transform: rotate(180deg);
  transition: transform 0.3s ease;
}

</style>


